import AddToCart from './AddToCart';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';

export default DisplayComponent(AddToCart);
